import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import { isError } from 'lodash';
export var isHttpSuccess = function isHttpSuccess(response) {
  var codeNumber = response;
  if (_typeof(codeNumber) === 'object') {
    codeNumber = response.status;
  }
  return isError(response) || codeNumber > 199 && codeNumber < 300;
};
//# sourceMappingURL=isHttpSuccess.js.map